module.exports = __webpack_public_path__ + "static/img/pbrand8.93ab87ca.png";